<template>
    <div
        class="modal fade"
        :id="'dispachModal' + name"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
    >
        <div
            class="modal-dialog modal-lg modal-dialog-centered"
            role="document"
        >
            <div class="modal-content">
                <div class="modal-header bg-dark text-light">
                    <h5 class="modal-title" id="exampleModalLabel">
                        {{ titulo ? titulo : "Gravador de audio" }}
                    </h5>

                    <!-- <button
                        type="button"
                        class="close text-light"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button> -->
                </div>
                <div class="modal-body">
                    <!-- criar um botão do bootstrap no centro redondo com o icone de um microfone -->
                    <div class="row mx-2">
                        <button
                            type="button"
                            class="btn btn-outline-success mr-2"
                            @click="startRecord"
                            v-if="recordStatus == 'stop'"
                        >
                            <i class="fas fa-microphone"></i>
                            Gravar
                        </button>

                        <button
                            type="button"
                            class="btn btn-outline-warning mr-2"
                            @click="pauseRecord"
                            v-else-if="recordStatus == 'recording'"
                        >
                            <i class="fas fa-pause"></i>
                            Pausar
                        </button>

                        <button
                            type="button"
                            class="btn btn-outline-primary mr-2"
                            @click="resumeRecord"
                            v-else-if="recordStatus == 'pause'"
                        >
                            <i class="fas fa-play"></i>
                            Continuar
                        </button>

                        <button
                            type="button"
                            class="btn btn-outline-danger mr-2"
                            @click="stopRecord"
                            v-if="recordStatus != 'stop'"
                        >
                            <i class="fas fa-stop"></i>
                            Parar
                        </button>
                        <div
                            v-if="recordStatus == 'recording'"
                            class="spinner-grow text-danger ml-4 mt-1"
                            role="status"
                        >
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>

                    <div class="mt-3">
                        <!-- <div class="mt-3" v-for="item in dados"> -->
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Enviar</th>
                                    <th>Audio</th>
                                    <th>Download</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in dados" :key="item.timestamp">
                                    <td class="text-center">
                                        <input
                                            class="mt-2"
                                            type="checkbox"
                                            v-model="item.checked"
                                        />
                                    </td>

                                    <td class="w-100">
                                        <audio
                                            class="w-100"
                                            :src="item.src"
                                            style="height: 30px;"
                                            controls
                                            controlsList="nodownload"
                                        ></audio>
                                    </td>
                                    <td class="text-center">
                                        <a
                                            class="btn btn-primary btn-sm"
                                            :href="item.src"
                                            :download="item.filename"
                                        >
                                            <i class="fas fa-download"></i>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <!-- </div> -->
                    </div>

                    <div class="progress mt-1 mb-1" v-if="$store.state.loading">
                        <div class="indeterminate"></div>
                    </div>

                    <pre v-if="1 == 0">{{ dados }}</pre>
                </div>
                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-secondary"
                        @click="fechar"
                    >
                        Fechar
                    </button>
                    <button
                        type="button"
                        class="btn btn-primary"
                        @click="enviar"
                    >
                        Enviar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
// import _ from "lodash";
// import { subscribe, unSubscribe } from "../../service/Notify.js";

export default {
    data() {
        return {
            dados: [],
            mediaRecorder: null,
            audioStream: null,
            chunksAudio: [],
            recordStatus: "stop"
        };
    },

    props: ["titulo", "name", "model_type", "model_id"],

    components: {},

    computed: {
        nome_modal: function() {
            return "dispachModal" + this.name;
        }
    },

    methods: {
        abrir: function() {
            this.init();

            this.show_modal();
        },

        fechar: function() {
            this.disconnect();
            this.hide_modal();
        },

        enviar: function() {
            const audios = this.dados.filter(item => item.checked);
            if (audios.length == 0) {
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Nenhum audio selecionado para envio!",
                    life: 3000
                });
                return;
            }
            this.$store.commit("loading", true);

            let formData = new FormData();
            formData.append("multiple", true);
            formData.append("model_type", this.model_type);
            formData.append("model_id", this.model_id);
            formData.append("tipo_especial", "audio");

            audios.forEach(item => {
                var file = new File([item.blob], item.filename, {
                    type: "audio/ogg; codecs=opus"
                });

                formData.append("files[]", file);
            });

            this.axios
                .post("upload_arquivo_atendimento", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                })
                .then(res => {
                    if (
                        res &&
                        res.status &&
                        (res.status == 200 || res.status == 201)
                    ) {
                        this.$toast.add({
                            severity: "success",
                            summary: "Sucesso",
                            detail: "Audio enviado com sucesso!",
                            life: 3000
                        });

                        this.$emit("refresh");

                        this.fechar();
                    } else {
                        console.log(res);
                        this.$toast.add({
                            severity: "error",
                            summary: "Erro",
                            detail: "Erro ao enviar audio!",
                            life: 3000
                        });
                    }
                })
                .finally(() => {
                    this.$store.commit("loading", false);
                });
        },

        init: function() {
            if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                console.log("getUserMedia supported.");
                navigator.mediaDevices
                    .getUserMedia({
                        audio: true
                    })
                    .then(stream => {
                        this.audioStream = stream;
                        this.$refs.audioControl.srcObject = stream;
                    })
                    .catch(err => {
                        console.log(err);
                    });
            } else {
                console.log("getUserMedia not supported on your browser!");
            }
        },

        startRecord: function() {
            const options = {
                audioBitsPerSecond: 128000,
                mimeType: "audio/webm"
            };

            this.mediaRecorder = new MediaRecorder(this.audioStream, options);

            this.mediaRecorder.start();
            this.recordStatus = "recording";
            console.log(this.mediaRecorder.state);
            console.log("recorder started");

            this.mediaRecorder.ondataavailable = e => {
                console.log("data available", e.data);
                this.chunksAudio.push(e.data);
            };

            this.mediaRecorder.onstop = () => {
                console.log("recorder stopped", this.chunksAudio);

                const blob = new Blob(this.chunksAudio, {
                    type: "audio/ogg; codecs=opus"
                });
                this.chunksAudio = [];
                const audioURL = window.URL.createObjectURL(blob);

                this.dados.push({
                    timestamp: new Date().getTime(),
                    checked: false,
                    src: audioURL,
                    filename: "audio_" + new Date().getTime() + ".ogg",
                    blob: blob
                });

                // if (this.audioStream) {
                //     this.audioStream.getTracks().forEach(track => {
                //         track.enabled = false;
                //     });
                // }
            };
        },

        stopRecord: function() {
            this.mediaRecorder.stop();
            this.recordStatus = "stop";
            console.log(this.mediaRecorder.state);
            console.log("recorder stopped");
        },

        pauseRecord: function() {
            this.mediaRecorder.pause();
            this.recordStatus = "pause";
            console.log(this.mediaRecorder.state);
            console.log("recorder paused");
        },

        resumeRecord: function() {
            this.mediaRecorder.resume();
            this.recordStatus = "recording";
            console.log(this.mediaRecorder.state);
            console.log("recorder resume");
        },

        disconnect: function() {
            this.audioStream.getTracks().forEach(function(track) {
                track.stop();
            });
            this.audioStream = null;
            console.log("diconnect");
        },

        show_modal: function() {
            $("#" + this.nome_modal).modal("show");
        },

        hide_modal: function() {
            $("#" + this.nome_modal).modal("hide");
        }
    },

    beforeDestroy() {
        // stop using the microphone
        console.log("beforeDestroy");
    },

    beforeUnmount() {
        // stop using the microphone
        console.log("beforeUnmount");
    },

    onUnmounted() {
        console.log("onUnmounted");
    }

    // mounted() {
    //     this.load();
    // }
};
</script>

<style></style>
